import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-primary-600">
      <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 dark:text-foreground-950 mb-4">
          开始您的 Hitozuma 文化探索之旅
        </h2>
        <p className="text-sm md:text-base text-background-200 dark:text-foreground-800 mb-8 leading-relaxed">
          无论您是初次接触 hitozuma 文化，还是已有深厚积累的研究者，这里都有适合您的内容。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/basics"
            className="px-8 py-3 bg-background-50 text-primary-700 rounded-full font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览入门指南
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 border border-background-50/30 rounded-full font-medium text-sm hover:bg-primary-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}